import { render, staticRenderFns } from "./IDC.vue?vue&type=template&id=0c0f450a&scoped=true"
import script from "./IDC.vue?vue&type=script&lang=js"
export * from "./IDC.vue?vue&type=script&lang=js"
import style0 from "./IDC.vue?vue&type=style&index=0&id=0c0f450a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f450a",
  null
  
)

export default component.exports